import React from 'react';
import { FadeIn } from './FadeIn';
import { motion } from 'framer-motion';
export function PricingCTA() {
  return <section id="pricing" className="py-14 px-6 relative overflow-hidden bg-[#161616]" data-id="element-208">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[500px] bg-brand-rose/8 rounded-full blur-[120px] pointer-events-none" data-id="element-209" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-210">
        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-211">
          <FadeIn direction="left" data-id="element-212">
            <div className="relative flex justify-center" data-id="element-213">
              <div className="absolute inset-0 bg-brand-rose/10 rounded-full blur-[80px] scale-75 pointer-events-none" data-id="element-214" />
              <img src="https://cdn.magicpatterns.com/uploads/7R22mtG57mGYPgAvs9jphH/ChatGPT_Image_29_mar_2026,_07_57_39_p.m..png" alt="Nunca Más Te Dejan en Visto" className="relative z-10 w-full max-w-lg rounded-2xl" data-id="element-215" />
            </div>
          </FadeIn>

          <FadeIn direction="right" data-id="element-216">
            <div className="relative bg-[#0a0a0a] border border-brand-rose/20 rounded-3xl p-6 md:p-8 overflow-hidden shadow-2xl" data-id="element-217">
              <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-rose to-rose-400" data-id="element-218" />

              <p className="text-brand-lightGray text-sm uppercase tracking-wider mb-2" data-id="element-219">
                Acceso inmediato
              </p>
              <h3 className="font-serif text-3xl font-bold text-brand-cream mb-6" data-id="element-220">
                El Sistema Completo
              </h3>

              <div className="flex items-baseline gap-2 mb-2" data-id="element-221">
                <span className="font-serif text-6xl font-bold text-brand-cream" data-id="element-222">
                  $24.000
                </span>
                <span className="text-brand-lightGray text-xl font-medium" data-id="element-223">
                  COP
                </span>
              </div>

              <div className="inline-block bg-red-500/10 border border-red-500/20 rounded-lg px-3 py-1.5 mb-6" data-id="element-224">
                <p className="text-red-400 font-medium text-sm flex items-center gap-2" data-id="element-225">
                  <span className="relative flex h-2 w-2" data-id="element-226">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-227"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-red-500" data-id="element-228"></span>
                  </span>
                  Este precio puede cambiar en cualquier momento
                </p>
              </div>

              <div className="p-4 bg-amber-500/10 border border-amber-500/20 rounded-xl mb-6" data-id="element-229">
                <p className="text-amber-400 font-bold text-sm mb-2" data-id="element-230">
                  🎁 BONOS GRATIS INCLUIDOS:
                </p>
                <ul className="space-y-1.5 text-brand-cream text-sm" data-id="element-231">
                  <li className="flex items-center gap-2" data-id="element-232">
                    <span className="text-amber-400" data-id="element-233">✔</span> 50 mensajes
                    listos para copiar y pegar
                  </li>
                  <li className="flex items-center gap-2" data-id="element-234">
                    <span className="text-amber-400" data-id="element-235">✔</span> Los 3 errores que
                    hacen que te ignoren
                  </li>
                </ul>
              </div>

              <motion.a href="https://oliverpublicista-2.myshopify.com/cart/43150580056154:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.97
            }} className="w-full group relative inline-flex items-center justify-center gap-2 px-6 py-5 bg-brand-rose text-white text-lg font-bold rounded-2xl overflow-hidden shadow-[0_0_30px_rgba(225,29,72,0.3)] hover:shadow-[0_0_50px_rgba(225,29,72,0.5)] transition-shadow text-center" data-id="element-236">
                <span className="relative z-10" data-id="element-237">
                  👉 QUIERO QUE ME VUELVA A RESPONDER
                </span>
                <div className="absolute inset-0 bg-white/15 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out" data-id="element-238" />
              </motion.a>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}